<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window copy-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="t-copy" :class="{'team' : type == 'team'}"></div>

                <div class="msg-view">
                    <p>邪魔乘音律自南风中来，妄图掌控深渊大殿，来势汹汹，天王魔力海势单力薄，为佑神殿不受魔音摧残，稳固大殿根基，特备丰厚奖励邀仙术师相助！</p>
                </div>

                <div class="reward-view">
                    <div class="reward-list">
                        <div class="reward-pic" v-for="(r,k) in list" :key="'r-' + k" v-tips="r.giftId">
                            <div class="pic-wrapper">
                                <game-item :id="r.giftId" :num="r.sendNum" :locked="true"></game-item>
                            </div>                           
                        </div>                          
                    </div>
                </div>

                <div class="u-btn copy" v-if="!$store.state.task['fz1'].giftRate"  @click="copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt"></div>
                <div class="u-btn dismiss" v-else></div>
            </div>       
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            iscopy : false,
            text : '请稍后……',
            shareTxt : '分享专属链接 开启助力',
            gid : '',
            mode : 1,
            ajax_error : false,
            type : '',
            list : [
                {
                    giftId: "PM95",
                    giftName: "五色神笔",
                    sendNum: "200"
                },
                {
                    giftId: "KR48",
                    giftName: "活跃自选礼包（7天）",
                    sendNum: "3"
                },
                {
                    giftId: "K907",
                    giftName: "两万士兵卷轴(30天)",
                    sendNum: "5"
                }
            ],       
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              //_this.$error_modal({text : "复制成功"});
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
              //_this.$error_modal({text : "复制失败"});
            });
        },             
    },
}
</script>

<style lang="scss" scoped>
    .dialog-view{
        z-index: 100;
    }

    .copy-modal{
        position: relative;
        width: 673px;
        height: 449px;
        background-image: url(~@/assets/images/modal/bg-modal.png);  
    }

    .t-copy{
        width: 588px;
        height: 53px;
        margin: 0 auto 16px;
        background-image: url(~@/assets/images/modal/title-invite.png);
    }


    .msg-view{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        height: 140px;
        line-height: 1.6;
        padding: 0 54px;
        font-size: 20px;
        text-align: center;

        color: #5e2f15;
    }

    .u-btn.copy{
        position: absolute;
        left: 50%;
        bottom: 34px;
        transform: translateX(-50%);
        width: 333px;
        height: 81px;
        background-image: url(~@/assets/images/modal/btn-copy.png);
    }         

    .u-btn.dismiss{
        position: absolute;
        left: 50%;
        bottom: 34px;
        transform: translateX(-50%);
        width: 317px;
        height: 63px;
        background-image: url(~@/assets/images/modal/btn-dismiss.png);
    }         
</style>